import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectEvent, FileInfo, RemoveEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { ItemDocument } from '../../../shared/interfaces/entities/item-document.interface';

@Component({
    selector: 'app-item-document',
    templateUrl: './item-document.component.html',
    styleUrl: './item-document.component.css',
    standalone: false
})
export class ItemDocumentComponent implements OnInit {

  @Input() entity: ItemDocument;
  @Output() submitForm: EventEmitter<FormData> = new EventEmitter();

  file: FileInfo;
  isNew: boolean = false;
  form: FormGroup;

  myRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png"],
  };

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.isNew = this.entity.id == undefined || this.entity.id == null || this.entity.id == 0;

    if (this.isNew) {
      this.entity.id = 0;
      var itemId = Number(window.location.pathname.split('/').at(-1));
      this.entity.itemId = itemId;
    }

    this.form = this.fb.group({
      id: [this.entity.id],
      itemId: [this.entity.itemId],
      name: [this.entity.name, Validators.required],
      description: [this.entity.description ?? null],
      file: [this.entity.file]
    });
  }

  onSelect(ev: SelectEvent) {
    if (ev.files) {
      ev.files.forEach((file: FileInfo) => {
        if (file.rawFile && !file.validationErrors) {
          this.file = file;
        }
      });
    }
  }

  save() {

    this.form.controls['file'].setValue(this.file);
    var formData = new FormData();
    for (var key in this.form.value) {
      formData.append(key, this.form.value[key]);
    }

    //if (this.isNew) {
    formData.append('file', this.file.rawFile as Blob);
    /*   }*/


    this.submitForm.emit(formData);
  }

}
